import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import ProgressBar from 'react-bootstrap/ProgressBar'

import { selectTranslations } from "../../../services/i18n/i18nSlice"
import { fetchGetOfaSubjects } from "../../../features/User/userApi"
import { TitleH2 } from "../../../components/TitleH2"
import { Text } from "../../../components/Text"
import SecureImage from "../../../components/_partials/SecuredImage"
import { API_URL } from "../../../config/constants"

import correct_img from '../../../assets/images/folders/correct.svg'
import incomplete_img from '../../../assets/images/ofa/incomplete_folder.svg'
import './OfaRecoveryStatus.css'


function SubjectList({title, subjects, statusImg}) {
    if (!subjects.length) return null
    return (
        <div className="mt-3">
            <Text className="ofa_recovery_label mb-2">{title}</Text>
            <ul className="ofa_recovery_list">
                {subjects.map(s =>
                    <li key={s.subject_id}>
                        {s.icon_url && <SecureImage height='20px' width='20px' className="ofa_recovery_icon" imageUrl={`${API_URL}${s.icon_url}`} />}
                        <span>{s.subject_name}</span>
                        <img src={statusImg} alt="" />
                    </li>
                )}
            </ul>
        </div>
    )
}

export default function OfaRecoveryStatus() {

    const t = useSelector(selectTranslations)
    const [subjects, setSubjects] = useState(null)

    useEffect(()=>{
        fetchGetOfaSubjects().then(response => {
            if (response?.success) setSubjects(response.data)
        })
    },[])

    const missing = subjects?.missing_subjects || []
    const recovered = subjects?.recovered_subjects || []
    const total = missing.length + recovered.length
    // nothing to show to users without ofa subjects
    if (!total) return null

    return (
        <div className="ofa_recovery">
            <TitleH2 className="ofa_recovery_title">{t.ofa.recovery.title}</TitleH2>
            <Text className="mb-2"><strong>{recovered.length} {t.ofa.of} {total}</strong> {t.ofa.recovery.progress}</Text>
            <ProgressBar now={recovered.length / total * 100} />
            {missing.length ?
                <SubjectList title={t.ofa.recovery.missing} subjects={missing} statusImg={incomplete_img} />
            :
                <Text className="mt-3 mb-0">{t.ofa.recovery.completed}</Text>
            }
            <SubjectList title={t.ofa.recovery.recovered} subjects={recovered} statusImg={correct_img} />
        </div>
    )
}
